import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Router, UrlHandlingStrategy } from '@angular/router';
import {
  Adherido,
  Cnae,
  Domicilio,
  listAdheridos,
} from '../../../models/adherido';
import { AttachedService } from '../../../services/attached.service';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { PreliminaryRegistrationComponent } from '../preliminary-registration/preliminary-registration.component';
import { DownloadService } from '../../../services/download.service';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';
import Swal from 'sweetalert2';
import { SpinnerService } from '../../../services/spinner.service';
import { Combo } from '../../../models/combo';
import { CombosService } from '../../../services/combos.service';
import { Tramo_cuota } from '../../../models/tramo_cuota';
import { zip } from 'rxjs';
import { SnackbarService } from '../../../services/snackbar.service';
import {
  ContratoControllerService,
  FacturaAdheridoControllerService,
  BusquedaAdheridoDTO,
  PageDTOAdheridoModel,
  AdheridoModel,
  AdheridoControllerService,
  DiccionarioControllerService,
  DiccionarioElementoDTO
} from 'api-rest';
import { AttachedStatusChangeDialogComponent } from '../attached-status-change-dialog/attached-status-change-dialog.component';
import { InitialDaeDialogComponent } from '../initial-dae-dialog/initial-dae-dialog.component';
import { AttachedBajaMotivoDialogComponent, TIPO_BAJA } from '../attached-baja-motivo-dialog/attached-baja-motivo-dialog.component';
import moment from 'moment';

@Component({
  selector: 'lib-attached-search',
  templateUrl: './attached-search.component.html',
  styleUrls: ['./attached-search.component.scss'],
})
export class AttachedSearchComponent implements OnInit, OnDestroy {
  pageNumber: number = 0;
  pageSize: number = 25;
  totalElements: number = 0;
  itemsPerPageOptions: number[] = [25, 50, 75, 100];
  selectedItemsPerPage: number = 25;
  flagSearch: boolean = false;
  defaultSort: string = '';
  currentSort: string = '';
  tiposDocumento: Combo[] = [];
  cifrasNegocio: Tramo_cuota[] = [];
  estados: any[] = [];
  headArray: any = [
    {
      Head: 'Id. Adherido',
      FieldName: 'id',
    },
    {
      Head: 'Documento',
      FieldName: 'codigoDocumento',
    },
    {
      Head: 'Razón social',
      FieldName: 'razonSocial',
      Tooltip: true,
      Maxtext: 60,
    },
    {
      Head: 'Grupo empresarial',
      FieldName: 'nombreGrupo',
    },
    {
      Head: 'Núm. registro de productor',
      FieldName: 'registroProductor',
    },
    {
      Head: 'Estado',
      FieldName: 'estado',
      Attribute: 'descripcion_corta',
      Tooltip: true,
    },
    {
      Head: 'Fecha inicio adhesión',
      FieldName: 'fechaInicioAdhesion',
      renderValue: (item: { fechaInicioAdhesion?: string }) =>
        item.fechaInicioAdhesion
          ? moment(item.fechaInicioAdhesion, 'YYYY-MM-DD').format('DD/MM/YYYY')
          : '',
    },
    {
      Head: 'CNAE principal',
      FieldName: 'cnae1',
      Attribute: 'descripcion',
      Tooltip: true,
      Maxtext: 60,
    },
    {
      Head: 'CNAE secundario',
      FieldName: 'cnae2',
      Attribute: 'descripcion',
      Tooltip: true,
      Maxtext: 60,
    },
    {
      Head: 'Comunidad autónoma',
      FieldName: 'domicilios',
      renderValue: (items: { domicilios: Domicilio[] }) => {
        const domicilioSocial = items.domicilios.find(
          (domicilio) => domicilio.tipoDireccion?.descripcion === 'Social'
        );
        return domicilioSocial?.provinciaRef?.comunidad?.nombre;
      },
    },
    {
      Head: 'Cifra de negocio',
      FieldName: 'cifraNegocio',
      Attribute: 'descripcion',
    },
    {
      Head: 'Acciones',
      FieldName: 'actions',
      check: false,
      buttons: [
        {
          nameButton: 'view',
          icon: 'open_in_new',
          toolTip: 'Detalle',
          show: { params: 'canAccessView', accion: 'view' },
        },
        // { 'nameButton': "edit", "icon": "edit_square", 'toolTip': 'Editar', 'show': { 'params': 'canAccessListEdit', 'accion': 'edit' } },
        {
          nameButton: 'delete',
          icon: 'delete',
          toolTip: 'Borrar',
          show: { params: 'canAccessDelete', accion: 'delete' },
        },
        {
          nameButton: 'menu',
          array: [
            {
              nameButton: 'content_paste',
              name: 'Generar contrato',
              show: {
                params: 'canAccessUpdatedContact',
                accion: 'content_paste',
              },
            },
                {
              nameButton: 'content_dae_initial',
              name: 'Generar DAE inicial',
              show: {
                params: 'canAccessUpdatedDaeInitial',
                accion: 'content_paste',
              },
            },
            // {
            //   nameButton: 'receipt_long',
            //   name: 'Generar factura proforma',
            //   show: { params: 'canAccessReceiptLong', accion: 'receipt_long' },
            // },
            {
              nameButton: 'cancel',
              name: 'Baja de adherido',
              show: { params: 'canAccessCancel', accion: 'cancel' },
            },
            {
              nameButton: 'initialPackagingDeclaration',
              name: 'Generar DAE inicial',
              show: { params: 'canAccessInitialPackagingDeclaration', accion: 'initialPackagingDeclaration' },
            },
          ],
        },
      ],
      width: '12',
      permanent: true,
    },
  ];

  gridArray: any[] = [];

  listDocumentType: any[] = [];

  searchForm: FormGroup;

  selectModelCnae: any = {
    id: null,
    iso: null,
    nombre: null,
  };

  updateList: boolean = false;
  cnaeEndpoint = this.environment.urlBackCore + 'api/v1/core/cnae';
  comunidadesEndpoint =
    this.environment.urlBackCore + 'api/v1/core/communities';
  flagDisabledForm: boolean = false;
  totalSearch: any = 0;
  mostrarFiltros: boolean = true;

orden: DiccionarioElementoDTO[] = [];
  constructor(
    private attachedService: AttachedService,
    private formBuilder: FormBuilder,
    private router: Router,
    public dialog: MatDialog,
    private downloadSrv: DownloadService,
    @Inject('EmpusaAuthenticationService')
    private authService: EmpusaAuthenticationService,
    @Inject('environment') private environment: any,
    public spinnerSrv: SpinnerService,
    public comboSrv: CombosService,
    private snackBarSrv: SnackbarService,
    private facturaService: FacturaAdheridoControllerService,
    private contratoController: ContratoControllerService,
    private adheridoService: AdheridoControllerService,
    private diccionarioControllerService: DiccionarioControllerService,
  ) {
    this.searchForm = this.formBuilder.group({
      identificador: [{ value: null, disabled: false }, [Validators.pattern('^[0-9;]+$')]],
      documentType: [{ value: null, disabled: false }],
      numRegistro: [{ value: null, disabled: false }],
      nombreGrupo: [{ value: null, disabled: false }],
      autonomia: [{ value: null, disabled: false }],
      document: [{ value: null, disabled: false }],
      rsocial: [{ value: null, disabled: false }],
      cifra: [{ value: null, disabled: false }],
      cnae: [{ value: null, disabled: false }],
      estado: [{ value: null, disabled: false }],
      fechaInicioAdhesionDesde: [{ value: null, disabled: false }],
      fechaInicioAdhesionHasta: [{ value: null, disabled: false }],
      orden: [{ value: null, disabled: false }],
      tipoOrden: [{ value: null, disabled: false }],
    });

    if(this.canViewRol('AD-ENV-GEST')){
      this.headArray.filter((item:any) => item.FieldName == 'actions')[0].check = true;
    }
    if(!this.canViewResource('AD-ENV-GEST') && !this.canViewResource('AD-ENV-CONS')){
      this.headArray = this.headArray.filter((item:any) => item.FieldName != 'fechaInicioAdhesion');
    }
  }

  getCneaFormControl(): FormControl {
    return this.searchForm.get('cnae') as FormControl;
  }

  abrirPantalla(id: number): void {
    this.attachedService.setTempRutaSearch(true);
    this.attachedService.searchForm = this.searchForm;
    const searchState = this.searchForm.getRawValue();
    searchState.fechaInicioAdhesionDesde = this.formatFecha(searchState.fechaInicioAdhesionDesde);
    searchState.fechaInicioAdhesionHasta = this.formatFecha(searchState.fechaInicioAdhesionHasta);
    this.router.navigate(['/attached-app/detail', id], {
      state: { searchForm: searchState }
    });
  }

  private formatFecha(fecha: any): string | undefined {
    return fecha ? moment(fecha).format('YYYY-MM-DD') : undefined;
  }

  ngOnInit(): void {
    this.cargarCombos();
    if (this.attachedService.getTempRutaSearch && this.attachedService.searchForm) {
      this.searchForm = this.attachedService.searchForm;
      this.attachedService.setTempRutaSearch(false);
    }

  }

  ngOnDestroy(): void {
    // Keep filters only when navigating to detail and returning back.
    if (!this.attachedService.getTempRutaSearch) {
      this.attachedService.searchForm = undefined;
    }
  }

  cargarCombos(): void {
    this.tiposDocumento = this.comboSrv.getTiposDocumentoIdentidad();
    zip(
      this.attachedService.getEstadosAdheridos(),
      this.attachedService.getTramos_cuota(),
      this.diccionarioControllerService.listarElementos(['ORDEN_ADHERIDOS_BUSQUEDA'])
    ).subscribe({
      next: (responses: any[]) => {
        this.estados = responses[0].content;
        this.cifrasNegocio = responses[1].content;
        
        // Restaurar formulario después de cargar combos
        const state: any = history.state;
        if (state && state.searchForm) {
          const { fechaInicioAdhesionDesde, fechaInicioAdhesionHasta, ...resto } = state.searchForm;
          this.searchForm.patchValue({
            ...resto,
            fechaInicioAdhesionDesde: fechaInicioAdhesionDesde ? moment(fechaInicioAdhesionDesde, 'YYYY-MM-DD') : null,
            fechaInicioAdhesionHasta: fechaInicioAdhesionHasta ? moment(fechaInicioAdhesionHasta, 'YYYY-MM-DD') : null,
          });
          this.searchData();
        }
        this.orden = responses[2]['ORDEN_ADHERIDOS_BUSQUEDA'];
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  getCnaDescription(cnae: Cnae) {
    return cnae.clase + ' - ' + cnae.descripcion;
  }

  getCnaeObjectQuery(searchterm: string) {
    return {
      descripcion: `or(ci(${searchterm}))`,
      clase: `or(ci(${searchterm}))`,
    };
  }

  renderPage(event: number) {
    this.pageNumber = event;
    if (this.flagSearch) {
      this.searchData();
    }
  }

  onItemsPerPageChange() {
    this.pageSize = this.selectedItemsPerPage;
    this.searchData();
  }

  checked(item: any) {
  }

  action(item: any) {
    if (item.nameButton == 'view') {
      this.abrirPantalla(item.id);
    }
    if (item.nameButton == 'edit') {
      this.abrirPantalla(item.id);
    }
    if (item.nameButton == 'cancel') {
      this.abrirDialogoMotivoBaja(item);
    } else if (item.nameButton == 'delete') {
      this.confirmacionEliminar(item);
    } else if (item.nameButton == 'content_paste') {
      this.spinnerSrv.loadingShow();
      this.contratoController.generarContrato(item.id).subscribe({
        next: () => {
          this.spinnerSrv.loadingHide();
          this.searchData();
          this.snackBarSrv.showSnackBar(
            'El contrato del Adherido ha sido generado correctamente. Se le ha enviado un email al Adherido con instrucciones para la firma del mismo.',
            'success'
          );
        },
        error: (err) => {
          this.spinnerSrv.loadingHide();
          if (err?.status === 409 && err?.error?.detail) {
            this.snackBarSrv.showInfoModal(err.error.detail);
          } else if (err?.error?.detail) {
            this.snackBarSrv.showSnackBar(err?.error?.detail, 'error');
          } else {
            this.snackBarSrv.showSnackBar(
              'Ha ocurrido un error durante la generación del contrato del Adherido',
              'error'
            );
          }
        },
      });
    } else if (item.nameButton == 'receipt_long') {
      this.spinnerSrv.loadingShow();
      this.facturaService.generarFactura(item.id).subscribe({
        next: () => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Se ha generado la factura proforma correctamente',
            'success'
          );
        },
        error: (err) => {
          this.spinnerSrv.loadingHide();
          if (err?.error?.detail) {
            this.snackBarSrv.showSnackBar(err?.error?.detail, 'error');
          } else {
            this.snackBarSrv.showSnackBar(
              'Ha ocurrido un error al generar la factura proforma',
              'error'
            );
          }
        },
      });
    } else if (item.nameButton == 'content_dae_initial') {

      this.openModalInitialDae(item);

     }else if(item.nameButton == 'initialPackagingDeclaration'){
      this.cambiarEstadoPendienteDeclaracionEnvasesInicial(item);
    }
  }

  cambiarEstadoPendienteDeclaracionEnvasesInicial(item: any) {
    this.adheridoService.multipleActualizarEstado(4, { adheridosIds: [item.id] }).subscribe({
      next: (value: any) => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar('Estado actualizado correctamente', 'success');
        this.searchData();
      },
      error: (err: { message: any }) => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar('Error al actualizar el estado', 'error');
      },
    });
  }

  private abrirDialogoMotivoBaja(item: any): void {
    const dialogRef = this.dialog.open(AttachedBajaMotivoDialogComponent, {
      width: '600px',
      maxWidth: '95%',
      maxHeight: '95vh',
      data: {
        adheridos: [item],
        tipoBaja: TIPO_BAJA,
      },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.darBajaAdherido(item, result);
      }
    });
  }

  private darBajaAdherido(item: any, datosBaja: any): void {
    this.spinnerSrv.loadingShow();
    this.attachedService
      .bajaAdherido(item.id, datosBaja)
      .pipe()
      .subscribe({
        next: (value: any) => {
          this.spinnerSrv.loadingHide();
          this.searchData();
        },
        error: (err: { message: any }) => {
          this.spinnerSrv.loadingHide();
        },
      });
  }

  openModalPreliminaryRegistration() {
    const dialogRef = this.dialog.open(PreliminaryRegistrationComponent, {
      width: '950px',
      maxWidth: '95%',
      maxHeight: '95vh',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }

  searchDataButton(){
    this.pageNumber = 0;
    this.searchData();
  }

  toggleFiltros(): void {
    this.mostrarFiltros = !this.mostrarFiltros;
  }

  quitarFiltro(filtro: { label: string; campo: string; value?: any }): void {
    if (filtro.value !== undefined) {
      const current = this.searchForm.get(filtro.campo)?.value as any[];
      if (Array.isArray(current)) {
        const updated = current.filter((v) => v !== filtro.value);
        this.searchForm.get(filtro.campo)?.setValue(updated.length ? updated : null);
      }
    } else {
      this.searchForm.get(filtro.campo)?.reset();
    }
    this.pageNumber = 0;
    //this.searchDataButton();
  }

  get filtrosAplicados(): { label: string; campo: string; value?: any }[] {
    const filtros: { label: string; campo: string; value?: any }[] = [];

    const id = this.searchForm.get('identificador')?.value;
    if (id) filtros.push({ label: ` ${id}`, campo: 'identificador' });

    const docType = this.searchForm.get('documentType')?.value;
    if (docType) {
      const found = this.tiposDocumento.find((t) => t.id === docType);
      filtros.push({ label: found?.name ?? docType, campo: 'documentType' });
    }

    const doc = this.searchForm.get('document')?.value;
    if (doc?.trim()) filtros.push({ label: doc.trim(), campo: 'document' });

    const rsocial = this.searchForm.get('rsocial')?.value;
    if (rsocial?.trim()) filtros.push({ label: rsocial.trim(), campo: 'rsocial' });

    const nombreGrupo = this.searchForm.get('nombreGrupo')?.value;
    if (nombreGrupo?.trim()) filtros.push({ label: nombreGrupo.trim(), campo: 'nombreGrupo' });

    const numRegistro = this.searchForm.get('numRegistro')?.value;
    if (numRegistro) filtros.push({ label: numRegistro, campo: 'numRegistro' });

    const autonomia = this.searchForm.get('autonomia')?.value;
    if (autonomia) filtros.push({ label: autonomia.nombre, campo: 'autonomia' });

    const cifra = this.searchForm.get('cifra')?.value;
    if (cifra !== null && cifra !== undefined) {
      const found = this.cifrasNegocio.find((c) => c.id === cifra);
      filtros.push({ label: found?.descripcion ?? String(cifra), campo: 'cifra' });
    }

    const estados = this.searchForm.get('estado')?.value as any[];
    if (estados?.length) {
      estados.forEach((estId: any) => {
        const found = this.estados.find((e) => e.id === estId);
        filtros.push({ label: found?.descripcion_corta ?? String(estId), campo: 'estado', value: estId });
      });
    }

    const cnaes = this.searchForm.get('cnae')?.value as any[];
    if (cnaes?.length) {
      cnaes.forEach((c: any) => {
        const label = c.clase ? `${c.clase} - ${c.descripcion ?? ''}` : String(c);
        filtros.push({ label: label.length > 35 ? label.slice(0, 33) + '…' : label, campo: 'cnae', value: c });
      });
    }
    const fechaInicioDesde = this.searchForm.get('fechaInicioAdhesionDesde')?.value;
    if (fechaInicioDesde) {
      filtros.push({
        label: `Inicio adhesión desde: ${moment(fechaInicioDesde).format('DD/MM/YYYY')}`,
        campo: 'fechaInicioAdhesionDesde',
      });
    }

    const fechaInicioHasta = this.searchForm.get('fechaInicioAdhesionHasta')?.value;
    if (fechaInicioHasta) {
      filtros.push({
        label: `Inicio adhesión hasta: ${moment(fechaInicioHasta).format('DD/MM/YYYY')}`,
        campo: 'fechaInicioAdhesionHasta',
      });
    }

const ordenes = this.searchForm.get('orden')?.value;
    if (Array.isArray(ordenes) && ordenes.length) {
      ordenes.forEach((ordenCodigo: any) => {
        filtros.push({
          label: `Orden: ${String(ordenCodigo)}`,
          campo: 'orden',
          value: ordenCodigo,
        });
      });
    } else if (ordenes) {
      filtros.push({ label: `Órdenes: ${String(ordenes)}`, campo: 'orden' });
    }

    const tipoOrden = this.searchForm.get('tipoOrden')?.value;
    if (tipoOrden) {
      const label =
        tipoOrden === 'ASC'
          ? 'Ascendente'
          : tipoOrden === 'DESC'
          ? 'Descendente'
          : String(tipoOrden);
      filtros.push({ label: `Tipo orden: ${label}`, campo: 'tipoOrden' });
    }
    return filtros;
  }

  searchData() {
    const { backendFilter, page, size, sort, orden, tipoOrden } = this.getBackendFilter();
    this.spinnerSrv.loadingShow();
    this.adheridoService
      .listarAdheridos(
        {
          page: page,
          size: size,
          sort: [sort],
        },
        backendFilter,
        orden,
        tipoOrden
      )
      .subscribe({
        next: (data: PageDTOAdheridoModel) => {
          if (data) {
            this.spinnerSrv.loadingHide();
            this.flagSearch = data.datos?.length != 0 ? true : false;
            this.gridArray = this.canAccessAll(data.datos);
            this.totalElements = data.paginacion?.totalElements ?? 0;
            this.totalSearch = this.gridArray.length;
          }
        },
        error: (error: any) => {
          this.spinnerSrv.loadingHide();
        },
      });
  }

  loadLocationData() {
    this.attachedService
      .getTiposCnae()
      .pipe()
      .subscribe({
        next: (data: any) => {
          this.listDocumentType = data.datos;
        },
      });
  }

  private getBackendFilter() {
      const selectEstado = this.searchForm.get('estado')?.value;
    let selectEstadosId: any[] = [];
    if (selectEstado !== undefined && selectEstado !== null) {
      selectEstadosId = selectEstado.map((objeto: any) =>
        objeto.id !== undefined ? objeto.id : objeto
      );
    }

    const selectCnae = this.searchForm.get('cnae')?.value;
    let selectCnaeClases: any[] = [];
    if (selectCnae !== undefined && selectCnae !== null) {
      selectCnaeClases = selectCnae.map((objeto: any) =>
        objeto.clase !== undefined ? objeto.clase : objeto
      );
    }

    const backendFilter: BusquedaAdheridoDTO = {
      id: this.searchForm.get('identificador')?.value,
      registroProductor: this.searchForm.get('numRegistro')?.value,
      nombreGrupo: this.searchForm.get('nombreGrupo')?.value ? this.searchForm.get('nombreGrupo')?.value.trim() : undefined,
      comunidadAutonoma: this.searchForm.get('autonomia')?.value?.id,
      codigoDocumento: this.searchForm.get('document')?.value,
      razonSocial: this.searchForm.get('rsocial')?.value ? this.searchForm.get('rsocial')?.value.trim() : undefined,
      cifraNegocio: this.searchForm.get('cifra')?.value,
      cnae: selectCnaeClases.length > 0 ? selectCnaeClases : undefined,
      estado: selectEstadosId,
      tipoDocumento: this.searchForm.get('documentType')?.value,
      fechaInicioAdhesionDesde: this.formatFecha(this.searchForm.get('fechaInicioAdhesionDesde')?.value),
      fechaInicioAdhesionHasta: this.formatFecha(this.searchForm.get('fechaInicioAdhesionHasta')?.value),
    };
    const page = this.pageNumber <= 1 ? 0 : this.pageNumber - 1;
    const sort = this.currentSort != '' ? this.currentSort : this.defaultSort;
    const orden = this.searchForm.get('orden')?.value;
    const tipoOrden = this.searchForm.get('tipoOrden')?.value;
    return { backendFilter, page, size: this.pageSize, sort, orden, tipoOrden };
  }

  clearSearcher() {
    this.searchForm.reset();
    this.currentSort = '';
    this.flagSearch = false;
    this.gridArray = [];
    this.pageNumber = 0;

  }
  exportarCsv() {
    const textFilter = (value: any) =>
      value?.trim() ? `ci(${value?.trim()})` : undefined;

    const { backendFilter, page, size, sort } = this.getBackendFilter();

    this.adheridoService.exportAdheridosCsv(backendFilter, 'response').subscribe({
      next: (response) => {
        this.downloadSrv.exportModal();
        this.spinnerSrv.loadingHide();
        // const filename = this.downloadSrv.getFileName(
        //   response.headers,
        //   'Exportacion_Adheridos.csv'
        // );
        // this.downloadSrv.downloadCSV(response.body!, filename!);
      },
      error: (err) => {
        console.log(err);
      },
    });
  }
  exportarPdf() {
    this.attachedService.exportarAdheridoPdf().subscribe({
      next: (response) => {
        this.downloadSrv.downloadBlob(response, 'adheridos.pdf');
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  public filterList(data: any) {}

  getFormControl(selectForm: any): FormControl {
    switch (selectForm) {
      case 'autonomia': {
        return this.searchForm.get('autonomia') as FormControl;
        break;
      }
      case 'cnae': {
        return this.searchForm.get('cnae') as FormControl;
        break;
      }
      default: {
        return this.searchForm.get('') as FormControl;
        break;
      }
    }
  }

  selectedModel() {}

  selectedModelCnae() {}

  public rightHolder(controlName: string) {
    let cl2 = '';
    if (
      (this.searchForm.controls[controlName]?.touched ||
        this.searchForm.controls[controlName]?.dirty) &&
      this.searchForm.controls[controlName]?.errors
    ) {
      cl2 = 'error-focus-input';
    } else {
      cl2 = 'success-focus-input';
    }
    return `${cl2}`;
  }

  canAccessPreliminaryDischarge(): boolean {
    return this.authService.can('adherido', 'create');
  }

  canAccessAll(list: any) {
    const resultView = this.authService.can('adherido', 'view');
    const resultListEdit = this.authService.can('adherido', 'update');
    const resultDelete = this.authService.can('adherido', 'delete');
    const resultUpdatedContact = this.authService.can(
      'adherido',
      'update-contract'
    );
    const resultReceiptLong = this.authService.can('adherido', 'update-bill');
    const resultCancel = this.authService.can('adherido', 'update-unregister');

    const listPermission = list.map((objeto: any) => {
      const estadoDelete =
        objeto.estado && [1, 2, 3, 8].includes(objeto.estado.id);
      const estadoUpdatedContact =
        objeto.estado && ((objeto.estado.id === 2) || objeto.estado.id === 8 || objeto.estado.id === 11);
      const estadoReceiptLong = objeto.estado && objeto.estado.id === 4;
      const estadoCancel = objeto.estado && (objeto.estado.id === 6 || objeto.estado.id === 4);
      const estadoUpdatedDaeInitial =
        objeto.estado && (objeto.estado.id === 2 && (objeto.scrapOrigen?.id !== 2 && objeto.scrapOrigen !== null));

      return {
        ...objeto,
        canAccessView: resultView,
        canAccessListEdit: resultListEdit,
        canAccessDelete: estadoDelete && resultDelete,
        canAccessUpdatedDaeInitial: estadoUpdatedDaeInitial && resultUpdatedContact,
        canAccessUpdatedContact: estadoUpdatedDaeInitial === false && estadoUpdatedContact && resultUpdatedContact,
        // canAccessReceiptLong: estadoReceiptLong && resultReceiptLong,
        canAccessCancel: estadoCancel && resultCancel,
        canAccessInitialPackagingDeclaration: this.canViewRol('AD-ENV-GEST') && objeto.estado?.id === 10,
      };
    });

    return listPermission;
  }

  showClearButton(formName: string): boolean {
    return this.searchForm.get(formName)?.value !== null;
  }

  clearSelection(event: Event, formName: string) {
    event.stopPropagation();
    this.searchForm.get(formName)?.setValue(null);
  }

  confirmacionEliminar(element?: any): void {
    Swal.fire({
      text: `¿Desea eliminar el adherido:"${element.id} - ${element.razonSocial}"?`,
      icon: 'question',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Sí',
      denyButtonText: 'No',
      allowOutsideClick: false,
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.eliminarAdherido(element);
      }
    });
  }

  eliminarAdherido(element?: any) {
    if (element?.id) {
      this.snackBarSrv.showSnackBar(
        `Adherido eliminado correctamente. El usuario ha sido dado de baja correctamente`,
        'success'
      );
      this.gridArray = this.gridArray.filter(
        (objeto) => objeto.id !== element.id
      );
      this.attachedService
        .deleteAdherido(element.id)
        .pipe()
        .subscribe({
          next: (value: any) => {
            this.spinnerSrv.loadingHide();
            // nota revisar servicio eliminar con back
            // this.snackBarSrv.showSnackBar('Adherido eliminado correctamente, Adherido dado de baja correctamente', 'success');
            // this.gridArray = this.gridArray.filter(objeto => objeto.id !== element.id);
          },
          error: (err: { message: any }) => {
            this.spinnerSrv.loadingHide();
            this.snackBarSrv.showSnackBar(
              'Ha ocurrido un error al eliminar el Adherido',
              'error'
            );
          },
        });
    }
  }

  onlyNumberKey(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete', 'Control'];

    if (event.ctrlKey && (event.key === 'c' || event.key === 'v')) return;

    if (!/^[0-9;]$/.test(event.key) && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  sortGrid(element: any){
    this.currentSort = '';
    let colName = element.name;
    if(colName != null && colName != undefined){
      if(colName == 'estado.descripcion_corta'){
        colName = 'estado';
      }else if(colName == 'domicilios'){
        colName = 'comunidad';
      }
      this.currentSort = `${colName},${element.type}`;
    }
    if(colName != ''){
      this.currentSort = `${colName},${element.type}`;
    }
    this.pageNumber = 0;
    this.searchData();
  }

  canViewRol(rol: string): boolean {
    return this.authService.hasCurrentUserRole(rol);
  }

  controlHasError(controlName: string, errorName: string): boolean {
    return (
      !!this.searchForm.controls[controlName]?.hasError(errorName) &&
      this.searchForm.controls[controlName].touched
    );
  }

  comprobarCambioEstado(){
    const list = this.gridArray
    .filter((x) => x.checked === true)
    .map((x) => x.id);

    if (list.length == 0) {
      this.snackBarSrv.showSnackBar(
        `Debe seleccionar al menos un adherido para realizar el cambio de estado.`,
        'error'
      );
      return;
    }
    const selectedAdheridos = this.gridArray.filter((adh:any) => list.includes(adh.id));
    const estadoActual = selectedAdheridos[0].estado.id;
    if(!selectedAdheridos.every((item:any) => item.estado.id == estadoActual)){
      this.snackBarSrv.showSnackBar(
        `Todos los adheridos seleccionados deben tener el mismo estado.`,
        'error'
      );
      return;
    }

    const dialogRef = this.dialog.open(AttachedStatusChangeDialogComponent, {
      width: '950px',
      maxWidth: '95%',
      maxHeight: '95vh',
      data: {
        adheridos: selectedAdheridos,
        estadoActual: estadoActual,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.pageNumber = 0;
        this.searchData();
      }
    });
  }

    openModalInitialDae(element?: any): void {
      const dialogRef = this.dialog.open(InitialDaeDialogComponent, {
        width: '500px',
        data: {
          itemOpen: element,
        },
        disableClose: true,
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.clearSearcher();
          this.searchData();
        }
      });
    }
    canViewResource(rol: string): boolean {
        return this.authService.hasCurrentUserRole(rol);
    } 
}
